import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://f366a8e4bc8ca08393bc9103fdd6cf13@o4505885589962752.ingest.us.sentry.io/4507590019907584",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});